'use strict';

angular.module('AcaApp').factory('LockedScreenService',
['$rootScope',
  function($rootScope){
    var countWindowsLoading = 0;
    var canOpenAutomatically = true;
    var setIsLoading = function(value){
      $rootScope.isLoading = value;
    };
    var setCanOpenAutomatically = function(value){
      canOpenAutomatically = value;
    };
    var isCanOpenAutomatically = function(){
      return canOpenAutomatically;
    };
    var openWindows = function(method){
      if(method !== 'import' && method !== 'ResetCurrentData'){
        setIsLoading(true);
        countWindowsLoading++;
      }
    };
    var closeWindows = function(){
      if(countWindowsLoading > 0){
        setIsLoading(false);
        countWindowsLoading--;
      }
    };
    return{
      disableAutomaticOpenWindow: function(){
        setCanOpenAutomatically(false);
      },
      enableAutomaticOpenWindows: function(){
        setCanOpenAutomatically(true);
        closeWindows();
      },
      openWindowsLoading: function(method){
        openWindows(method);
      },
      closeWindowsLoading: function(data){
        if(data !== undefined && _.isArray(data.result) && data.result.length === 0){
          this.enableAutomaticOpenWindows();
          return;
        }
        if(isCanOpenAutomatically()){
          closeWindows();
        }
      }
    };
  }
]);